import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout"
import { config } from "@/configuration/app/app-config"
import { useAppSelector } from "@/redux/store"
import { getLanguageSettings } from "@/redux/lang.selector"
import useIncomingPostMessages from "@rio-cloud/rio-uikit/useIncomingPostMessages"
import { EMBED_SHOW_NOTIFICATION } from "@/components/TransportExecution/EventActions"
import { showEmbedNotification } from "@/components/TransportExecution/embedNotifications"

export const TransportExecutionFrame = () => {
    const locale: string = useAppSelector(getLanguageSettings).locale
    const src = `${config.transportExecutionFrontend.url}?theme=rio&language=${locale}`

    useIncomingPostMessages({
        handlers: {
            [EMBED_SHOW_NOTIFICATION]: showEmbedNotification,
        },
    })

    return <ApplicationLayout.Body className={"print-area"} innerClassName={"padding-0"}>
        <iframe
            src={src}
            title={"Transport Execution"}
            className={"unstyled full-window"}
            style={{ border: "0px" }}
        />
    </ApplicationLayout.Body>
}
